<div *ngIf="!submitSuccess" class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Forgot password</h1>
      <p>Enter your email to have your password emailed to you.</p>
      <form [formGroup]="form" (ngSubmit)="submit(form.value)">
        <fieldset [disabled]="waiting">
          <div class="form-group">
            <mat-form-field class="simple-form-field-100">
              <mat-label>Email</mat-label>
              <input
                matInput
                placeholder="Email"
                name="email"
                formControlName="email"
              />
            </mat-form-field>
            <br />
            <div class="button-right-container">
              <div></div>
              <div>
                <div class="spinner-container" *ngIf="waiting">
                  <mat-spinner diameter="24"></mat-spinner>
                </div>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="waiting"
                  type="submit"
                  value="submit"
                >
                  Submit
                </button>
              </div>
            </div>
            <span *ngIf="formErrorMessage" class="text-error-color">
              {{ formErrorMessage }}
            </span>
          </div>
        </fieldset>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<div *ngIf="submitSuccess" class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>

      <h1>Password reset sent</h1>

      <p>We sent a password reset link to your email.</p>
    </mat-card-content>
  </mat-card>
</div>
